module.exports = __webpack_public_path__ + "src/assets/img/eng-hot-white.d46b825b.svg";